
const replyComment = () => {

	// reply to comment 
	const replyBtn = document.querySelectorAll('.custom-comment-reply-link');
	for (let item of replyBtn) {
		item.addEventListener('click', (e) => {
			e.preventDefault();
			// id comment parent
			const commentParent = item.getAttribute('data-commentid');

			const panelToOpen = document.querySelector("#panel-reply-form");
			panelToOpen.classList.add('panel-open');

			// get content of current comment, and insert it in the panel 
			const comment = document.querySelector('#comment-' + commentParent);
			const commentMeta = comment.querySelector('.comment-meta').cloneNode(true);
			const commentContent = comment.querySelector('.comment-content').cloneNode(true);
			const commentReply = document.querySelector("#panel-reply-form .commentToReply");
			commentReply.innerHTML = '';// on vide avant
			commentReply.appendChild(commentMeta);
			commentReply.appendChild(commentContent);

			//insert id of the parent id
			const commentParentInput = document.querySelector("#panel-reply-form #comment_parent");
			commentParentInput.value = commentParent;
		});
	}
	//----- 

}

export default replyComment;
